import { SET_CONTEXT_UUID, SET_OUTCOMES_ENDPOINT, SET_OUTCOMES_TOKEN, SET_EXTERNAL_ACCOUNT_UUID } from '@instructure/quiz-common';
export function setContextUuid(contextUuid) {
  return {
    type: SET_CONTEXT_UUID,
    payload: contextUuid
  };
}
export function setExternalAccountUuid(externalAccountUuid) {
  return {
    type: SET_EXTERNAL_ACCOUNT_UUID,
    payload: externalAccountUuid
  };
}
export function setOutcomesEndpoint(endpoint) {
  return {
    type: SET_OUTCOMES_ENDPOINT,
    payload: endpoint
  };
}
export function setOutcomesToken(token) {
  return {
    type: SET_OUTCOMES_TOKEN,
    payload: token
  };
}